/** Earliest year shown in payment / invoice year pickers. */
export const PAYMENT_YEAR_START = 2026;

/** Current calendar year as string (default selection). */
export function defaultPaymentYear(): string {
  return String(new Date().getFullYear());
}

/**
 * Payment years from PAYMENT_YEAR_START through the current year,
 * optionally including next year for advance billing.
 */
export function getPaymentYearOptions(includeNextYear = true): number[] {
  const current = new Date().getFullYear();
  const end = includeNextYear ? current + 1 : current;
  const years: number[] = [];
  for (let y = PAYMENT_YEAR_START; y <= end; y++) years.push(y);
  return years;
}
